"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var UserTranslationStore = /*#__PURE__*/function (_RootStore) {
  function UserTranslationStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, UserTranslationStore);
    _this = _callSuper(this, UserTranslationStore);
    _this.config = {
      model: _models.UserTranslation,
      deserialize: true,
      GET: {
        index: '/user_translations'
      },
      PUT: {
        update: '/user_translations/:userTranslationId'
      },
      POST: {
        create: '/user_translations'
      },
      DELETE: {
        destroy: '/user_translations?translation_id=:translation_id',
        destroy_all: '/user_translations/destroy_all'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(UserTranslationStore, _RootStore);
  return (0, _createClass2["default"])(UserTranslationStore, [{
    key: "getReviews",
    value: function getReviews() {
      this.api({}, this.afterGetReviews, 'GET', 'reviews');
    }
  }, {
    key: "afterGetReviews",
    value: function afterGetReviews(resp) {
      this.reviews = resp;
    }
  }, {
    key: "destroyAll",
    value: function destroyAll() {
      this.api({}, this.afterDestroyAll.bind(this), 'DELETE', 'destroy_all');
    }
  }, {
    key: "afterDestroyAll",
    value: function afterDestroyAll() {
      this.getIndex();
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new UserTranslationStore();